import axios from './config'
const apiRentQuarterly = {
  rentItemQuarterly (id) {
    return axios.post(`/api/packageitems/${id}/rent_for_longer/`)
  },
  getRentForLongerPreview (id, promoCode = null) {
    let url = `/api/packageitems/${id}/rent_for_longer/?preview=True`
    if (promoCode) {
      url += `&promo_code=${promoCode}`
    }
    return axios.post(url)
  }
}
export default apiRentQuarterly